var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"repairSucess-container"},[_c('div',{staticClass:"repairSucess-main"},[_c('i',{staticClass:"el-icon-success"}),_c('p',{staticClass:"font-format-normal"},[_vm._v(_vm._s(_vm.msg))])])])}
var staticRenderFns = []

export { render, staticRenderFns }